import { boolean, object } from 'yup';

export const schema = object()
  .shape({
    mind: boolean().default(false).nullable(),
    startChat: boolean().default(false).nullable(),
    replyToExistingChats: boolean().default(false).nullable(),
    startMedicationRequest: boolean().default(false).nullable(),
    deleteChat: boolean().default(false).nullable(),
  })
  .required()
  .noUnknown();
